import { isAttributionCookieSet, setAttributionCookie } from '@/lib/attribution'

export default (app) => {
  if (!isAttributionCookieSet()) {
    setAttributionCookie()
  }
}
